import { render, staticRenderFns } from "./updateI9.vue?vue&type=template&id=495661e6&"
import script from "./updateI9.vue?vue&type=script&lang=js&"
export * from "./updateI9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports